/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/Visibility';
import { RoutePath } from 'shared/enums/RoutePath';
import store from '../../../redux/store';
import { toggleRemoveUserDialog, updateUserId } from '../../../redux/features/user/remove/user.removeFromOrg.slice';
import history from '../../../history';

const editEntry = isAdmin => ({
  id: 'actions.row.edit',
  text: 'actions.user.edit',
  ariaLabel: 'actions.row.edit',
  tooltipText: 'actions.edit',
  icon: <EditIcon />,
  ...(isAdmin ? { disabled: false } : { disabled: true }),
  active: true,
  onClick: (row) => {
    const currentOrganizationId = row['groups.0.id'];
    if (history) {
      history.push(
        RoutePath.generateRoutePath(RoutePath.USER_PROFILE_EDIT_ROLE, {
          userId: row.id,
          currentOrgId: currentOrganizationId,
        }),
      );
    }
  },
});

const deleteEntry = isAdmin => ({
  id: 'actions.row.remove',
  ariaLabel: 'actions.row.remove',
  text: 'actions.remove',
  tooltipText: 'actions.remove',
  icon: <CloseIcon />,
  ...(isAdmin ? { disabled: false } : { disabled: true }),
  active: true,
  onClick: (row) => {
    store.dispatch(updateUserId(row.id));
    store.dispatch(toggleRemoveUserDialog(true));
  },
});

const viewEntry = () => ({
  id: 'actions.row.view',
  ariaLabel: 'actions.row.view',
  text: 'actions.user.view',
  tooltipText: 'actions.view',
  icon: <ViewIcon />,
  disabled: false,
  active: true,
  onClick: (row) => {
    const currentOrganizationId = row['groups.0.id'];
    if (history)
      history.push(
        RoutePath.generateRoutePath(RoutePath.USER_PROFILE_VIEW, {
          userId: row.id,
          currentOrgId: currentOrganizationId,
        }),
      );
  },
});

export const computeCombinedCellEntries = (row, isAdmin) => {
  const entries = [editEntry(isAdmin), deleteEntry(isAdmin), viewEntry()];
  return entries;
};
